var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('headerSection',{attrs:{"menuData":_vm.menuData}}),_c('div',{staticClass:"d-flex"},[(_vm.authorized)?_c('Sidebar',{staticClass:"d-none d-xl-block",attrs:{"menuData":_vm.menuData}}):_vm._e(),_c('div',{staticClass:"contain-main gept_main_bg3 flex-1 p-2 p-xl-4"},[_c('router-view',{staticClass:"view_contain"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }